import { useRef, useState, useEffect } from 'react'
import crosssimgiocn from "../../src/Images/crosssimgiocn.png";
// import threedowttsimhgicon from "../../src/Images/threedowttsimhgicon.png";
import postbanneimmhg from "../../src/Images/postbanneimmhg.png";
import prodlikeicon from "../../src/Images/prodlikeicon.png";
import commenytstproodiuificon from "../../src/Images/commenytstproodiuificon.png";
import cmtprofileoneimg from "../../src/Images/cmtprofileoneimg.png";
// import cmtprofiletwoimg from "../../src/Images/cmtprofiletwoimg.png";
import msgiocn from "../../src/Images/msgiocn.png";
import Neoologoasjji from "../../src/Images/Neoologoasjji.png";
import { formatDateAgo } from '../utils/Helper';
import { useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import { commentAdd, ShareModalonOff } from '../Redux/Slice/PostSlice';
import { useDispatch, useSelector } from 'react-redux';
import ProfileShare from './ProfileShare';
import { LoadBusinessPostsInBackground } from '../Redux/Slice/BusinessPostSlice';

const Ownpostpagemodal = ({ closemodal, data }) => {
    const divSectionRef = useRef(null);
    const [text, setText] = useState("");
    const [commentboxmodal, setCommentboxmodal] = useState(false);
    const [loadmoremodala, setLoadmoremodala] = useState(false);
    const [threedpotsspclmodal, setThreedpotsspclmodal] = useState(false);

    const commentsboxoscopemnn = () => {
        setCommentboxmodal(!commentboxmodal);
    }

    // const lodamoisrrdedivbmodal = () => {
    //     setLoadmoremodala(!loadmoremodala)
    // }

    const threedotssettingclcil = () => {
        setThreedpotsspclmodal(!threedpotsspclmodal)
    }

    const location = useLocation();
    const copyPostLink = (e, postId) => {
        e.preventDefault()
        const postUrl = `${window.location.origin}/ownpostpage/${postId}`;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(postUrl).then(() => {
                toast.success("Copied Successfully");
                setThreedpotsspclmodal(false)
            });
        } else {
            toast.error("Clipboard not supported in this browser.")
        }
    }

    const { ShareModalOpenClose, UserProfileID, SingleUserData } = useSelector((state) => state.app);
    const dispatch = useDispatch()
    const [sharemodal, setSharemodal] = useState(false);
    const [postLink, setPostLink] = useState("")

    const shareClick = (e, postId) => {
        e.preventDefault()
        const postUrl = `${window.location.origin}/ownpostpage/${postId}`;
        setPostLink(postUrl)
        setSharemodal(!sharemodal);
        dispatch(ShareModalonOff(true));
    };

    const [commentText, setCommentText] = useState("")
    const handleCommentSend = (e, postId) => {
        e.preventDefault()
        const data = {
            postId: postId,
            comment: commentText
        }

        dispatch(commentAdd(data))
        dispatch(LoadBusinessPostsInBackground())
        setCommentText("")
    }

    // const divRef = useRef(null);
    const handleClickOutside = (e) => {
        if (divSectionRef.current && !divSectionRef.current.contains(e.target)) {
            setThreedpotsspclmodal(false)
        }
    };

    useEffect(() => {
        // Add event listener when the component mounts
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Cleanup the event listener when the component unmounts
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            <div className='otherprofudvtmodalbackbox'>
                <div className='post-modal-popup-box'>

                    {/* <div className='threedorttsdcoroodivflx'>
                    <div className='threediostyiicpn'>
                    <i className="fa-solid fa-ellipsis"></i>
                    </div>
                    <div className='imnmnproduuccrtisocross' onClick={() => closemodal()}>
                        <img src={crosssimgiocn} alt='...' />
                    </div>
                </div> */}

                    <div className='produtitleimggsdescrdivnewallada'>

                        <div className='allpostowndmaimndivallelemntnesmain'>
                            <div className='allpostowndmaimndivallelemnt'>
                                <div className='allpostimagedesuigfnatinob'>
                                    <div className='allposttslodjjimg'>
                                        <img src={data?.userData?.businessProfilePic || Neoologoasjji} alt='...' />
                                    </div>
                                    <div className=''>
                                        <h4 className='neeporoalposttsheadr'>{data?.userData?.companyName}</h4>
                                        {/* <p className='cmskshhstdiifgysyttxtpop'>{data?.userData?.businessProductCat?.join(" | ")}</p> */}
                                        <p className='cmskshhstdiifgysyttxtpop'>{data?.userData?.companytypename}</p>
                                    </div>
                                </div>
                                <div className='crosasddoproidikdsjbhidivflx'>
                                    <div className='threediostyiicpnggsuc'>
                                        <div className='threediostyiicpn' onClick={threedotssettingclcil} style={{ cursor: "pointer" }}>
                                            <i className="fa-solid fa-ellipsis"></i>
                                        </div>
                                        {threedpotsspclmodal && <div className='threedotssettingdiv' ref={divSectionRef}>
                                            <ul className="userMenu">
                                                <li>
                                                    <a
                                                        href="javascript:"
                                                        onClick={(e) => copyPostLink(e, data?._id)}
                                                    >
                                                        <i className="fa-solid fa-link mr-2"></i>
                                                        Copy post link
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        href="javascript:"
                                                        onClick={(e) => shareClick(e, data?._id)}
                                                    >
                                                        <i className="fa-solid fa-share-nodes  mr-2"></i>
                                                        Share post link
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="/">

                                                        <i className="fa-regular fa-bookmark mr-2"></i>
                                                        Save post
                                                    </a>
                                                </li>

                                                <li>
                                                    <a href="/">

                                                        <i className="fa-solid fa-eye-slash mr-2"></i>
                                                        Not interested
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>}
                                    </div>


                                    <div className='crossidovpostimgdiv' onClick={() => closemodal()} style={{ cursor: "pointer" }}>
                                        <img src={crosssimgiocn} alt='...' />
                                    </div>
                                </div>
                            </div>

                            <div className='beaiuttisprofuductimh'>
                                <img src={data?.file || postbanneimmhg} alt={data?.subject} title={data?.subject} />
                            </div>
                        </div>

                        <div className=''>
                            <p className='producttdescttxpppyip' style={{ font: "500 17px / 20px Roboto", marginBottom: "3px" }}>{data?.subject || "..."}</p>
                        </div>
                        <div className=''>
                            <p className='producttdescttxpppyip'>{data?.description || "..."}</p>
                        </div>

                        <div className=''>
                            <p className='timttksopooiisuttxpp'>
                                {formatDateAgo(data?.createdOn)}
                            </p>
                        </div>
                    </div>

                    <div className={commentboxmodal ? 'heijggsctrdjpprodfuiiciv actv' : "heijggsctrdjpprodfuiiciv"}>
                        <div className='producudtlikecomrnttsennsuiquerydiv'>
                            <div className='prodctlikecmntenquerydiv'>
                                <div className='produucvtsdlikeinmncomnfdivvhjjd'>
                                    <div className='produucvtsdlikeinmncomnf'>
                                        <img src={prodlikeicon} alt='' />

                                    </div>
                                    <p className='likkskjsbtcomnbvtyoipuxtt'>Like <span>{data?.PostLikeCount}</span></p>
                                </div>

                                <div className='produucvtsdlikeinmncomnfdivvhjjd' onClick={commentsboxoscopemnn}>
                                    <div className='produucvtsdlikeinmncomnf'>
                                        <img src={commenytstproodiuificon} alt='' />

                                    </div>
                                    <p className='likkskjsbtcomnbvtyoipuxtt'>Comment </p>
                                </div>


                                <div className='produucvtsdlikeinmncomnfdivvhjjd'>
                                    <div className='produucvtsdlikeinmncomnf'>
                                        <img src={msgiocn} alt='' />

                                    </div>
                                    <p className='likkskjsbtcomnbvtyoipuxtt'>Send Equiry </p>
                                </div>
                            </div>
                        </div>

                        {commentboxmodal &&

                            <div className='producytppostcommnentdiv'
                                style={{ display: "none" }}
                            >
                                <div className='commuisonnporttsidivrrls'>
                                    {/* <div
                                    ref={divRef}
                                    contentEditable
                                    className='textardibbrdrdivmain'
                                >
                                    {text}
                                </div>
                                <div className='posyynbmrmodiuvvmain'>
                                    <button className='posyynbmrmodiuvsujusvbntn'>Post</button>
                                </div> */}


                                    <div className='textareadibmainmainbrdrnewalada'>
                                        <div className='textareadibmain'>
                                            <textarea rows={4} cols={4} className='textareadibmainrerarenewalada' placeholder='Write a Comment'
                                                onChange={(e) => setCommentText(e.target.value)}
                                                value={commentText || ""}
                                            />
                                        </div>
                                        <div className="mesagsendidvmain"
                                            onClick={(e) => handleCommentSend(e, data?._id)}
                                        >
                                            <button className='posyynbmrmodiuvsujusvbntn'>Post</button>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        }

                        <div className='commenytstthowitxtpehht'>
                            {
                                data?.PostCommentData?.map((comment, index) => {
                                    return (
                                        <>
                                            <div className='commentshpwfrsttcmontdiv' key={index}>
                                                <div className='profikellcmnjhhrrddivflxttst'>
                                                    <div className='profikellcmntimgdivflxttst'>
                                                        <div className='commentproofilleimg'>
                                                            <img src={comment?.commentedBy[0]?.profilePhoto || cmtprofileoneimg} alt='...' />
                                                        </div>
                                                        <p className='commporosttxttnamepp'>{comment?.commentedBy[0]?.personName}</p>
                                                    </div>

                                                    <p className='commporosttxttnamepp'>{formatDateAgo(comment?.createdOn)}</p>
                                                </div>
                                                <p className='commsoprpodttctxppp'>
                                                    {comment?.comment}
                                                </p>
                                            </div>
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>

            {ShareModalOpenClose && (
                <ProfileShare
                    whatsApp={postLink}
                    linkedInLink={postLink}
                    facebookLink={postLink}
                    userLink={postLink}
                    instaLink={postLink}
                    emailId={postLink}
                // closeModal={setSharemodal}
                />
            )}
        </>

    )
}

export default Ownpostpagemodal
